<script>
import config from "../../config";
import { bannerService } from "../../services";
import { success_message, error_message } from "../../Helper/helper";
import pagination from "laravel-vue-pagination";
import PageHeader from "../../components/page-header";
import draggable from "vuedraggable";

export default {
	name: "banner-list-table",
	components: { pagination, PageHeader, draggable },
	props: {
		banners: {
			type: [Array, Function],
			required: true
		},
		fields: {
			type: [Array, Function],
			required: true
		},
		paginations: {
			type: [Object, Function],
			required: true
		},
		loading: {
			type: Boolean,
			required: true
		},
		sortBy: {
			type: String,
			required: true
		}

	},
	data() {
		return {
			config: config,
			limit: 1
		}
	},
	methods: {
		sortingChanged(ctx) {
			this.$emit('sortingChanged', ctx);
		},
		deleteById(id) {
			if (confirm("Are you sure you want to delete?")) {
					bannerService.deletebanner({ id: id }).then((response) => {
					error_message(response.data.message);
					this.$emit('callBanner');
				});
			}
		},
		getBanner() {
			this.$emit('callBanner');
		},
		onDragEnd() {
			const order = this.banners.map((item, index) => ({ id: item.id, order: index + 1 }));
			bannerService.reorderBanner({ order: order }).then(response => {
				success_message(response.data.message);
			}).catch(error => {
				console.error("Error updating order:", error);
				error_message(response.data.message);
			});
		}
	}
	
}
</script>

<template>
	<div class="row">
	  <div class="col-12 table-main-list banner-table table-responsive">
		<!-- Table structure with draggable only applied to rows -->
		<table class="table table-bordered">
		  <thead>
			<tr>
			  <th v-for="field in fields" :key="field.key">{{ field.label }}</th>
			</tr>
		  </thead>
		  	<template v-if="loading">
				<tbody>
					<tr>
						<td colspan="6">
							<div class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>{{ trans.get("__JSON__.Loading...") }}</strong>
							</div>
						</td>
					</tr>
				</tbody>
			</template>
			<template v-else-if="!loading && banners.length > 0">
				<draggable
					group="banners" :list="banners" @end="onDragEnd"
					v-model="banners" tag="tbody"
				>
					<tr v-for="item in banners" :key="item.id">
						<td v-for="field in fields" :key="field.key">
							<template v-if="field.key === 'image'">
								<div v-if="item.image">
									<img
									alt
									title="product-img"
									class="avatar-md rounded-circle-banner"
									v-lazy="(item.banner_image_path + '/thumb/' + item.image) || config.no_image"
									/>
								</div>
								<div v-else>
									<img
									class="avatar-md rounded-circle-banner"
									:src="config.basepath + 'no-img.png'"
									alt
									/>
								</div>
							</template>
							
							<template v-else-if="field.key === 'name'">
								<h5 class="font-size-14">
									<div v-if="item.name.length > 15">{{ item.name.substr(0, 15) + '...' }}</div>
									<div v-else>{{ item.name }}</div>
								</h5>
							</template>

							<template v-else-if="field.key === 'restaurants'">
								<template v-for="(restaurant, index) in item.restaurants">
									<span :key="restaurant.id">{{ restaurant.name }}</span>
									<span v-if="index + 1 !== item.restaurants.length">, </span>
								</template>
							</template>

							<template v-else-if="field.key === 'banner_type'">
								<h5 class="font-size-14">
									<div>
									{{ item.banner_type === '1' 
										? trans.get('__JSON__.Delivery - Takeaway') 
										: (item.banner_type === '2' ? trans.get('__JSON__.Dine In') : '-') }}
									</div>
								</h5>
							</template>

							<template v-else-if="field.key === 'status'">
								<div v-if="item.status === '1'" class="badge badge-pill badge-soft-success font-size-12">
									{{ trans.get('__JSON__.Active') }}
								</div>
								<div v-else class="badge badge-pill badge-soft-danger font-size-12">
									{{ trans.get('__JSON__.Inactive') }}
								</div>
							</template>

							<template v-else-if="field.key === 'action'">
								<div class="vendor-btn">
								<router-link
									v-if="$auth.hasPermission(config.permissions.banner_write)"
									:to="{ name: 'banner-edit', params: { id: base64(item.id) } }"
									class="btn btn-success btn-sm btn-rounded"
								>
									{{ trans.get('__JSON__.Edit') }}
								</router-link>
								<button
									v-if="$auth.hasPermission(config.permissions.banner_write)"
									type="submit"
									class="btn btn-danger btn-sm btn-rounded ml-1"
									@click="deleteById(base64(item.id))"
								>
									{{ trans.get('__JSON__.Delete') }}
								</button>
								</div>
							</template>
							<template v-else>
								{{ item[field.key] }}
							</template>
						</td>
					</tr>
				</draggable>
			</template>
			<template v-else-if="!loading && banners.length == 0">
				<tbody>
					<tr>
						<td colspan="6" class="text-center">{{ trans.get("__JSON__.No Banner") }}</td>
					</tr>
				</tbody>
			</template>

			
		</table>
	  </div>
  
	  <div class="row col-sm-5 offset-sm-7">
		<div class="col">
		  <div class="dataTables_paginate paging_simple_numbers float-right">
			<ul class="pagination pagination-rounded mb-0">
			  <pagination
				:data="paginations"
				:limit="limit"
				@pagination-change-page="getBanner"
			  ></pagination>
			</ul>
		  </div>
		</div>
	  </div>
	</div>
  </template>
  